import { Button, If } from '@paytrace/pt-skel/Component'
import * as React from 'react'
import { useState } from 'react'
import EDInputText from '../../../../../Component/EnhancedData/EDInputText'
import { tableColumnTypes } from '../../../../../Component/EnhancedData/SortableTable/TableBody'
import { DataWithKey, TextFieldDefinition } from '../../../../../Component/EnhancedData/Types'
import { RedSolidExclamationIcon } from '../../../../../Component/Icons'
import { ED_FIELD_SPEC, INLINE_PRODUCT_FORM_ERR_BANNER_MSG } from '../../../../../Helper/EnhancedData/Constants'
import { toMap } from '../../../../../Helper/util'
import * as EDT from '../../../../../Type/EnhancedData'

const fieldDefs: DataWithKey<TextFieldDefinition>[] = [
  {
    key: 'productLabel',
    name: 'productLabel',
    label: 'Product Label',
    tooltip: ED_FIELD_SPEC.line_item.productName.tooltip,
    showRequired: true,
    maxLength: ED_FIELD_SPEC.line_item.productName.maxLength,
    minLength: ED_FIELD_SPEC.line_item.productName.minLength,
    pattern: ED_FIELD_SPEC.line_item.productName.pattern,
    errorMessage: ED_FIELD_SPEC.line_item.productName.errorMessage,
  },
  {
    key: 'productCode',
    name: 'productCode',
    label: 'Product Code',
    tooltip: ED_FIELD_SPEC.line_item.productCode.tooltip,
    showRequired: true,
    maxLength: ED_FIELD_SPEC.line_item.productCode.maxLength,
    minLength: ED_FIELD_SPEC.line_item.productCode.minLength,
    errorMessage: ED_FIELD_SPEC.line_item.productCode.errorMessage,
  },
  {
    key: 'commodityCode',
    name: 'commodityCode',
    label: 'Commodity Code',
    tooltip: ED_FIELD_SPEC.line_item.commodityCode.tooltip,
    showRequired: true,
    maxLength: ED_FIELD_SPEC.line_item.commodityCode.maxLength,
    minLength: ED_FIELD_SPEC.line_item.commodityCode.minLength,
    pattern: ED_FIELD_SPEC.line_item.commodityCode.pattern,
    errorMessage: ED_FIELD_SPEC.line_item.commodityCode.errorMessage,
  },
  {
    key: 'unitOfMeasure',
    name: 'unitOfMeasure',
    label: 'Unit of Measure',
    tooltip: ED_FIELD_SPEC.line_item.unitOfMeasure.tooltip,
    showRequired: true,
    maxLength: ED_FIELD_SPEC.line_item.unitOfMeasure.maxLength,
    minLength: ED_FIELD_SPEC.line_item.unitOfMeasure.minLength,
    errorMessage: ED_FIELD_SPEC.line_item.unitOfMeasure.errorMessage,
    pattern: ED_FIELD_SPEC.line_item.unitOfMeasure.pattern,
  },
  {
    key: 'costPerUnit',
    name: 'costPerUnit',
    label: 'Cost Per Unit',
    tooltip: ED_FIELD_SPEC.line_item.costPerUnit.tooltip,
    showRequired: true,
    maxLength: ED_FIELD_SPEC.line_item.costPerUnit.maxLength,
    minLength: ED_FIELD_SPEC.line_item.costPerUnit.minLength,
    pattern: ED_FIELD_SPEC.line_item.costPerUnit.pattern,
    errorMessage: ED_FIELD_SPEC.line_item.costPerUnit.errorMessage,
    dataType: tableColumnTypes.money,
  },
]
const fieldDefMap: Record<string, DataWithKey<TextFieldDefinition>> = toMap(fieldDefs)

export enum EnhancedProductAction {
  CREATE_NEW,
  EDIT_EXISTING,
}

export interface EnhancedProductFormProps {
  productAction: EnhancedProductAction
  initialValues: EDT.LineItemStateData | null
  onSave: (newValues: EDT.LineItemStateData | null) => void
  onCancel: () => void
  changeHandler: (name: string, value: any) => void;
  bottomRef?: React.RefObject<HTMLDivElement>
}

const formConfig = {
  [EnhancedProductAction.CREATE_NEW]: {
    title: 'Create New Product',
    buttonValue: 'saveProduct',
    buttonText: '+ Add Product Item',
  },
  [EnhancedProductAction.EDIT_EXISTING]: {
    title: 'Edit Product',
    buttonValue: 'editProduct',
    buttonText: 'Edit Product Item',
  },
}

export function EnhancedProductForm (props: EnhancedProductFormProps): React.ReactElement {
  const { productAction, initialValues, onSave, onCancel, changeHandler } = props
  const { title, buttonValue, buttonText } = formConfig[productAction]
  const [productFormErrors, setProductFormErrors] = useState<Record<string, string>>({})
  const [displayProductFormErrorBanner, setDisplayProductFormErrorBanner] = useState<boolean>(false)

  const handleProductFormError = (fieldName: string, errorMessage: string | null) => {
    setProductFormErrors(prev => {
      const nextErrors = { ...prev }
      if (errorMessage) {
        nextErrors[fieldName] = errorMessage
      } else {
        delete nextErrors[fieldName]
      }
      return nextErrors
    })
  }

  const isProductFormValid = Object.entries(productFormErrors).length === 0

  const validateAndSave = () => {
    if (isProductFormValid) {
      onSave(initialValues)
    } else {
      setDisplayProductFormErrorBanner(true)
    }
  }

  return (
    <>
        <div className={'product-form'}>
            <h3>{title}</h3>
            <div className={'two-input-filled-row'}>
              <div className={'product-label-input-box'}>
                <EDInputText
                  value={initialValues?.productLabel}
                  fieldDefinition={fieldDefMap.productLabel}
                  onInputChange={changeHandler}
                  className={'add-line-item-input'}
                  onProductFormError={handleProductFormError}
                  runValidationNow={false}/>
                </div>
            </div>
            <div className={'two-column-row'}>
              <div className={'two-column-item'}>
                <EDInputText
                  value={initialValues?.productCode}
                  fieldDefinition={fieldDefMap.productCode}
                  onInputChange={changeHandler}
                  className={'add-line-item-input'}
                  onProductFormError={handleProductFormError}
                  runValidationNow={false}
                />
              </div>
              <div className={'two-column-item'}>
                <EDInputText
                  value={initialValues?.commodityCode}
                  fieldDefinition={fieldDefMap.commodityCode}
                  onInputChange={changeHandler}
                  className={'add-line-item-input'}
                  onProductFormError={handleProductFormError}
                  runValidationNow={false}
                />

              </div>
           </div>
           <div className={'two-column-row'}>
               <div className={'two-column-item'}>
                 <EDInputText
                   value={initialValues?.unitOfMeasure}
                   fieldDefinition={fieldDefMap.unitOfMeasure}
                   onInputChange={changeHandler}
                   className={'add-line-item-input'}
                   onProductFormError={handleProductFormError}
                   runValidationNow={false}
                 />
               </div>
               <div className={'two-column-item'}>
                 <EDInputText
                   value={initialValues?.costPerUnit}
                   fieldDefinition={fieldDefMap.costPerUnit}
                   onInputChange={changeHandler}
                   className={'add-line-item-input'}
                   onProductFormError={handleProductFormError}
                   prefixInput={'$'}
                   runValidationNow={false}
                 />
               </div>
           </div>
            <div>
              <If is={displayProductFormErrorBanner}>
                <div className={'enhanced-data-product-form-error-banner'}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <RedSolidExclamationIcon/>
                    <span style={{ marginLeft: '8px' }}>{INLINE_PRODUCT_FORM_ERR_BANNER_MSG}</span>
                  </div>
                </div>
              </If>
            </div>

          <div className={'two-column-row product-submit-row'}>
            <div className={'two-column-item'}>
              <div className={'product-submit'}>
                <Button className='data-save-button primary-btn submit-button' id={'save-product-btn'} value={buttonValue} onClick={() => validateAndSave()}>
                   <span className={'save-enhanced-data-btn'}>{buttonText}</span>
                </Button>
                 <Button className='product-form-cancel-button' id={'cancel-btn'} onClick={onCancel}>
                   <span className={'save-product-form-btn'}>Cancel</span>
                 </Button>
              </div>
            </div>
          </div>
          <div ref={props.bottomRef} />
        </div>
    </>
  )
}
